import { ComponentType } from 'react';
import { Bullseye, EyeFill, HeartFill } from 'react-bootstrap-icons';

export interface MVVItem {
  id: string;
  title: string;
  description: string;
  Icon: ComponentType;
}

export const ABOUT_CONTENT = {
  subtitle:
    'A StaffPlus nasceu com o propósito de organizar e profissionalizar as rotinas de Recursos Humanos das empresas, especialmente as que atuam na construção civil.',
  mvv: [
    {
      id: 'mission',
      title: 'Missão',
      description: 'Simplificar e fortalecer a gestão de RH com foco na conformidade e eficiência.',
      Icon: Bullseye,
    },
    {
      id: 'vision',
      title: 'Visão',
      description: 'Ser referência em gestão terceirizada de RH e rotinas trabalhistas.',
      Icon: EyeFill,
    },
    {
      id: 'values',
      title: 'Valores',
      description:
        'Responsabilidade, transparência, comprometimento, eficiência e valorização das pessoas.',
      Icon: HeartFill,
    },
  ] as MVVItem[],
} as const;
